import { ChatMessage } from '../shared/interfaces';

const isEmptyReasoning = (item: any) => item?.type === 'reasoning' && !item.reasoning;

/**
 * History after a turn fails. The send creates the assistant bubble with an
 * empty, pending reasoning item (the instant "Pensando"); when the request is
 * refused before any generation (e.g. the free-message quota, 402) that bubble
 * must go, or the spinner stays on screen next to the error. A bubble that did
 * get content keeps it, but nothing in it keeps spinning.
 */
export function settleFailedTurn(history: ChatMessage[]): ChatMessage[] {
  const last: any = history[history.length - 1];
  if (!last || last.role !== 'assistant') return history;
  const content = last.content;
  if (!content || (typeof content === 'string' && content.trim() === '')) return history.slice(0, -1);
  if (!Array.isArray(content)) return history;
  const kept = content.filter((item: any) => !isEmptyReasoning(item));
  if (kept.length === 0) return history.slice(0, -1);
  const settled = kept.map((item: any) => (item?.pending ? { ...item, pending: false } : item));
  return [...history.slice(0, -1), { ...last, content: settled }];
}
